import { useTranslation } from '@klv/hooks/useTranslation';

const useSelectedSearches = () => {
  const { t } = useTranslation();

  // randomize suggested searches
  const suggestedSearchOptions = Array.from({ length: 6 }, (_, i) => i + 1);
  const shuffled = suggestedSearchOptions.sort(() => 0.5 - Math.random());

  return [
    t(`pages_search_suggestedSearches_search${shuffled[0]}`),
    t(`pages_search_suggestedSearches_search${shuffled[1]}`),
    t(`pages_search_suggestedSearches_search${shuffled[2]}`),
  ];
};

export default useSelectedSearches;
